module.exports = "../images/times.svg?v=98d7863";